export default "__VITE_ASSET__DHLioJuC__"